import { useState, useCallback } from 'react'
import { imageFallbackChain } from '../utils/imageUrl'

type ApiImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  /** Filename (e.g. donating-food.jpg) or /images/... path */
  src: string
}

/**
 * Tries API image URL first, then same-origin /images/ static file.
 */
export function ApiImage({ src, onError, ...props }: ApiImageProps) {
  const chain = imageFallbackChain(src)
  const [index, setIndex] = useState(0)
  const currentSrc = chain[Math.min(index, chain.length - 1)]

  const handleError = useCallback(
    (e: React.SyntheticEvent<HTMLImageElement>) => {
      if (index < chain.length - 1) {
        setIndex((i) => i + 1)
        return
      }
      onError?.(e)
    },
    [index, chain.length, onError]
  )

  return <img {...props} src={currentSrc} onError={handleError} crossOrigin="anonymous" />
}

export default ApiImage
